import { ApiError } from "@/shared/api/httpClient";

/**
 * 「今日商机已满」(1006 演示机最终回归):今日页已满 10 条时,一次招投标发现精判留下 32 条却一条进不了,照扣 180。
 *
 * api 契约(2bf9d257):发起发现时今日商机已满 → HTTP 409,code=CONFLICT(没有新错误码),
 *   message「今日商机已满 N 条上限,明天再找或先处理现有商机」。不调上游、不扣费。
 * ★ 409 CONFLICT 同时也是「这一轮还在找」—— 同码不同文案,**只按 message 前缀「今日商机已满」区分**。
 * 不命中 → null,调用方行为不变(照旧 errorToast)。
 */
export const TODAY_FULL_PREFIX = "今日商机已满";

export function todayFullReasonOf(e: unknown): string | null {
  if (!(e instanceof ApiError)) return null;
  const msg = (e.message ?? "").trim();
  return msg.startsWith(TODAY_FULL_PREFIX) ? msg : null;
}

/**
 * 点之前就判(api 契约同上):今日接口已回 `total >= cap` ⇒「今日商机已满 N 条」。
 * 老后端没回 total(批次二前只发 `{cap, items}`)⇒ null,不判 —— 拿猜的数禁按钮会把能跑的线锁死。
 */
export function todayFullFromView(
  view: { cap?: number | null; total?: number | null } | null | undefined
): string | null {
  const cap = view?.cap;
  const total = view?.total;
  if (typeof cap !== "number" || typeof total !== "number" || cap <= 0) return null;
  return total >= cap ? `${TODAY_FULL_PREFIX} ${cap} 条` : null;
}
